import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlaceholderProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.85714 6.50037C7.85714 5.29177 8.81607 4.31287 10 4.31287C11.1839 4.31287 12.1429 5.29177 12.1429 6.50037C12.1429 7.70896 11.1839 8.68787 10 8.68787C8.81607 8.68787 7.85714 7.70896 7.85714 6.50037ZM13.4286 6.50037C13.4286 4.56716 11.8938 3.00037 10 3.00037C8.10625 3.00037 6.57143 4.56716 6.57143 6.50037C6.57143 8.43357 8.10625 10.0004 10 10.0004C11.8938 10.0004 13.4286 8.43357 13.4286 6.50037ZM5.28571 16.1254C5.28571 14.1922 6.82054 12.6254 8.71429 12.6254H11.2857C13.1795 12.6254 14.7143 14.1922 14.7143 16.1254V16.3441C14.7143 16.7078 15.0009 17.0004 15.3571 17.0004C15.7134 17.0004 16 16.7078 16 16.3441V16.1254C16 13.4676 13.8893 11.3129 11.2857 11.3129H8.71429C6.11071 11.3129 4 13.4676 4 16.1254V16.3441C4 16.7078 4.28661 17.0004 4.64286 17.0004C4.99911 17.0004 5.28571 16.7078 5.28571 16.3441V16.1254Z",
		fill: "#0D2976"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4 16.5004C4 16.2242 4.22386 15.7 4.5 15.7H15.5C15.7761 15.7 16 16.2242 16 16.5004C16 16.7765 15.7761 17.0004 15.5 17.0004H4.5C4.22386 17.0004 4 16.7765 4 16.5004Z",
		fill: "#0D2976"
	})]
});
export default SvgPlaceholderProfile;
